module.exports = __webpack_public_path__ + "img/BZ.231f036c.png";